import _ from 'lodash'
import { httpMutationHelper } from 'glonass/core/utils'
import * as types from './mutation-types'

export default {
  [types.SET_INITIAL_STATE] (state, values) {
    // с глубокой вложенностью могут быть проблемы
    _.each(values, (value, prop) => {
      state[prop] = value
    })
  },

  ...httpMutationHelper(types.PUT_TO_CART, 'cart'),
  ...httpMutationHelper(types.REMOVE_FROM_CART, 'cart'),
  ...httpMutationHelper(types.CREATE_ORDER, 'order')
}



// WEBPACK FOOTER //
// ./dev-packages/Shop/assets/site/store/mutations.js